const HUAWEI_MODEL_PREFIXES = [
  'ALP', 'BLA',
  'EML', 'CLT',
  'HMA', 'LYA', 'EVR',
  'ELE', 'VOG',
  'TAS', 'LIO',
  'ANA', 'ELS', 'JNY',
  'OCE', 'NOH', 'NOP',
  'ABR', 'JAD', 'BAL',
  'CET', 'DCO',
  'LNA', 'MNA',
  'BRA', 'ALN', 'ALT',
  'ADY', 'HBN', 'HBP', 'VDE',
  'CLS', 'PLR', 'PLA'
]

const HUAWEI_MODEL_PREFIX_RE = new RegExp(
  `(${HUAWEI_MODEL_PREFIXES.join('|')})-`,
  'i'
)

export function isHuaweiCameraRuntime () {
  const ua = String((typeof navigator !== 'undefined' && navigator.userAgent) || '')
  if (/HUAWEI|Huawei/i.test(ua)) {
    return true
  }
  return HUAWEI_MODEL_PREFIX_RE.test(ua)
}

export function findHuaweiMainBackCamera (devices) {
  return (devices || []).find((device) => {
    if (!device || !device.deviceId) {
      return false
    }
    const label = String(device.label || '').toLowerCase()
    if (!label || /front|user|前/.test(label)) {
      return false
    }
    return /camera2?\s*0/.test(label) && /back|rear|environment|后|背/.test(label)
  }) || null
}
